import "./App.css";
import { Route } from 'react-router-dom'
import MatchingBancario from "./pages/matching-bancario/MatchingBancario.jsx"
import MatchingJudicial from "./pages/matching-judicial/MatchingJudicial.jsx"
import Detalle from "./pages/matching-bancario/detalle/index.jsx"
import DetalleJudicial from "./pages/matching-judicial/detalle/index.jsx"
import NotFound from "./pages/not-found/Index.jsx"
import { AppRouter, AuthKeycloak } from '@artprov/design-system';
import { ErrorBoundary } from '@sentry/react';
import { RoleGuard } from "./components/RoleGuard.jsx";
import { MatchingLayout } from "./pages/matching/MatchingLayout.jsx";
import { MatchingRouter } from "./pages/matching/MatchingRouter.jsx";


function App() {
  return (
    <ErrorBoundary>
      <AppRouter>
        <AuthKeycloak
          keycloakConfig={{
            url: import.meta.env.VITE_KEYCLOAK_URL,
            realm: import.meta.env.VITE_KEYCLOAK_REALM,
            clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
          }}
          apiConfig={{
            consumidor: "Embargos",
            services: [
              {
                name: "default",
                baseURL: import.meta.env.VITE_API_URL,
              },
              {
                name: "no-retry",
                baseURL: import.meta.env.VITE_API_URL,
                config: {
                  retryConfig: { retries: 0, retryDelay: 0 },
                },
              },
            ],
          }}
          accessRole={import.meta.env.VITE_KEYCLOAK_ACCESS_ROLE || "acceso-embargos"}
        >
          {/* Ruta raíz: redirige según rol */}
          <Route path="/" element={<MatchingRouter />} />

          {/* Matching Bancario: requiere sge_contable o sge_view_all */}
          <Route
            path="/matching-bancario"
            element={
              <RoleGuard roles={['sge_contable', 'sge_view_all']}>
                <MatchingLayout>
                  <MatchingBancario />
                </MatchingLayout>
              </RoleGuard>
            }
          />

          {/* Matching Judicial: requiere sge_legales o sge_view_all */}
          <Route
            path="/matching-judicial"
            element={
              <RoleGuard roles={['sge_legales', 'sge_view_all']}>
                <MatchingLayout>
                  <MatchingJudicial />
                </MatchingLayout>
              </RoleGuard>
            }
          />

          {/* Rutas de detalle (protegidas por el mismo RoleGuard) */}
          <Route
            path="/matching-bancario/:id"
            element={
              <RoleGuard roles={['sge_contable', 'sge_view_all']}>
                <Detalle />
              </RoleGuard>
            }
          />

          <Route
            path="/matching-judicial/detalle"
            element={
              <RoleGuard roles={['sge_legales', 'sge_view_all']}>
                <DetalleJudicial />
              </RoleGuard>
            }
          />

          <Route path="*" element={<NotFound />} />
        </AuthKeycloak>
      </AppRouter>
    </ErrorBoundary>
  );
}


export default App;
